/**
 * AccordionControl
 * Collapsible panel container for form controls.
 */

import React, { useState, memo } from 'react';
import type { FormControl } from '@atlas-forms/types-js';
import { ChevronUpIcon, ChevronDownIcon } from '@atlas-forms/ui-components-react';

export interface AccordionControlProps {
  control: FormControl & { children?: FormControl[] };
  renderChild: (child: FormControl) => React.ReactNode;
}

export const AccordionControl = memo(function AccordionControl({ control, renderChild }: AccordionControlProps) {
  const defaultExpanded = (control as any).defaultExpanded !== false;
  const [expanded, setExpanded] = useState(defaultExpanded);
  const children = control.children ?? [];

  return (
    <div className="accordion-control" data-control-id={control.id}>
      <button
        type="button"
        aria-expanded={expanded}
        onClick={() => setExpanded((v) => !v)}
        className="accordion-control__header"
      >
        {control.label ?? 'Section'}
        <span className="accordion-control__icon">{expanded ? <ChevronUpIcon width={16} height={16} /> : <ChevronDownIcon width={16} height={16} />}</span>
      </button>
      {expanded && (
        <div className="accordion-control__body">
          {children.map((child) => (
            <React.Fragment key={child.id}>{renderChild(child)}</React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
});
